export enum AccountStatus {
  ACTIVE = 'ACTIVE',
  INACTIVE = 'INACTIVE',
  FROZEN = 'FROZEN'
}

// access api type
export enum CardAccountStatus {
  ACTIVE = 'active',
  FROZEN = 'frozen'
}

export enum CardAccountStatusColor {
  'ACTIVE' = 'Green',
  'FROZEN' = 'Red',
  // access api type
  'active' = 'Green',
  'frozen' = 'Red',
}

export enum TransactionStatus {
  PENDING = 'pending',
  SUCCESS = 'posted',
  DECLINED = 'declined',
  VOID = 'void'
}

export enum CardStatus {
  ACTIVE = 'active',
  PENDING_ACTIVATION = 'pending-activation',
  LOCKED = 'locked',
  SUSPENDED = 'suspended',
  CANCELLED = 'cancelled'
}

export enum CardType {
  ASSET_LINK = 'asset-link',
  PREPAID = 'prepaid'
}

export enum CardLimitType {
  DailyPurchaseLimit = 'PurchaseLimit',
  AtmLimit = 'ATMWithdrawalLimit',
  DailyLimit = 'DailyLimit',
  SingleTransactionLimit = 'SingleTransactionLimit'
}
